var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Bold-Outline",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.816,
    height: 16.212,
    viewBox: "0 0 19.816 16.212",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shape",
    d: "M20.815,8.384q0,.021,0,.041V15.61a3.6,3.6,0,0,1-3.6,3.6H4.6A3.6,3.6,0,0,1,1,15.61V8.425Q1,8.4,1,8.384V6.6A3.6,3.6,0,0,1,4.6,3h12.61a3.6,3.6,0,0,1,3.6,3.6Zm-1.8-.65V6.6a1.8,1.8,0,0,0-1.8-1.8H4.6A1.8,1.8,0,0,0,2.8,6.6V7.734l7.847,2.354a.9.9,0,0,0,.518,0Zm0,1.881-7.33,2.2a2.7,2.7,0,0,1-1.553,0L2.8,9.615V15.61a1.8,1.8,0,0,0,1.8,1.8h12.61a1.8,1.8,0,0,0,1.8-1.8Z",
    transform: "translate(-1 -3)",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.955fab06073542f63be519ffe183c363.svg";
export { ForwardRef as ReactComponent };